import axios from "axios";
import axiosClient from "../axiosClient";

const buildBaseQuery = ({ from, to, device_id } = {}) => {
  const query = {};

  if (from) {
    query.from = from;
  }

  if (to) {
    query.to = to;
  }

  if (device_id !== "" && device_id !== null && device_id !== undefined) {
    query.device_id = device_id;
  }

  return query;
};

const extractEnvelopeData = (response) => {
  const envelope = response?.data;

  if (!envelope?.success) {
    const error = new Error(envelope?.message || "errors.failed_to_fetch_data");
    error.customMessage = envelope?.message || "errors.failed_to_fetch_data";
    throw error;
  }

  return envelope.data;
};

const analyticsService = {
  async getRevenueTimeline({ from, to, device_id, granularity = "day" } = {}) {
    const params = {
      ...buildBaseQuery({ from, to, device_id }),
      granularity,
    };

    const response = await axiosClient.get("/analytics/revenue-timeline", { params });
    return extractEnvelopeData(response);
  },

  async getPaymentSplit({ from, to, device_id } = {}) {
    const params = buildBaseQuery({ from, to, device_id });
    const response = await axiosClient.get("/analytics/payment-split", { params });
    return extractEnvelopeData(response);
  },

  async getHourlyMap({ from, to, device_id } = {}) {
    const params = buildBaseQuery({ from, to, device_id });
    const response = await axiosClient.get("/analytics/hourly-map", { params });
    return extractEnvelopeData(response);
  },

  async getTopHours({ from, to, device_id } = {}) {
    const params = buildBaseQuery({ from, to, device_id });
    const response = await axiosClient.get("/analytics/top-hours", { params });
    return extractEnvelopeData(response);
  },

  async getTopTemplates({
    from,
    to,
    device_id,
    metric = "revenue",
    limit = 10,
  } = {}) {
    const safeLimit = Math.max(1, Math.min(50, Number(limit) || 10));

    const params = {
      ...buildBaseQuery({ from, to, device_id }),
      metric,
      limit: safeLimit,
    };

    const response = await axiosClient.get("/analytics/top-templates", { params });
    return extractEnvelopeData(response);
  },

  async getPriceInsight({ from, to, device_id } = {}) {
    const params = buildBaseQuery({ from, to, device_id });
    const response = await axiosClient.get("/analytics/price-insight", { params });
    return extractEnvelopeData(response);
  },

  async getExecutiveSummary({ from, to, device_id } = {}) {
    const params = buildBaseQuery({ from, to, device_id });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/analytics/executive-summary`,
        {
          params,
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );

      const envelope = response?.data;

      if (envelope?.success === false) {
        const error = new Error(envelope?.message || "errors.failed_to_fetch_data");
        error.status = response?.status;
        error.customMessage = envelope?.message || "errors.failed_to_fetch_data";
        throw error;
      }

      return envelope?.data || null;
    } catch (error) {
      if (error.response) {
        const wrapped = new Error(
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "errors.failed_to_fetch_data"
        );
        wrapped.status = error.response.status;
        wrapped.customMessage = wrapped.message;
        throw wrapped;
      }

      throw error;
    }
  },
};

export default analyticsService;
